import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'

const CoresightTooltip = props => {
  const { id, title, children, placement = 'bottom' } = props
  return (
    <Tooltip id={id} title={title} placement={placement}>
      {children}
    </Tooltip>
  )
}

export default CoresightTooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip.js